import { render, staticRenderFns } from "./DrugsWarehousing.vue?vue&type=template&id=02b1a484&scoped=true"
import script from "./DrugsWarehousing.vue?vue&type=script&lang=js"
export * from "./DrugsWarehousing.vue?vue&type=script&lang=js"
import style0 from "./DrugsWarehousing.vue?vue&type=style&index=0&id=02b1a484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b1a484",
  null
  
)

export default component.exports